import { SimpleReactComponentProps } from "../../../types/components";

export interface RichTextProps extends SimpleReactComponentProps {
    richText: string;
    className?: string;
};

export const RichText = ({ richText, className }: RichTextProps) => {
    return <section dangerouslySetInnerHTML={
        { __html: richText }
    } className={className} />;
};